import { render, staticRenderFns } from "./status6.vue?vue&type=template&id=08cf8018&scoped=true&"
import script from "./status6.vue?vue&type=script&lang=js&"
export * from "./status6.vue?vue&type=script&lang=js&"
import style0 from "./status6.vue?vue&type=style&index=0&id=08cf8018&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cf8018",
  null
  
)

export default component.exports